<template>
  <pt-integral-goods-review class="pt-integral-goods-review__withData" ref="table" @approvalReject="approvalReject" @offTheShelf="offTheShelf"></pt-integral-goods-review>
</template>

<script>
import PtIntegralGoodsReview from './index'
export default {
  name: 'pt-integral-goods-review__withData',
  components: {
    'pt-integral-goods-review': PtIntegralGoodsReview
  },
  methods: {
    approvalReject (id) {
      this.$store.dispatch('integralGoodsReject', id).then(res => {
        this.$message.success('驳回审核成功')
        this.$refs.table.getTableData()
      }).catch(err => {
        this.$message.error(err || '驳回审核失败')
      })
    },
    offTheShelf (id) {
      this.$store.dispatch('offTheShelf', id).then(res => {
        this.$message.success('下架商品成成功')
        this.$refs.table.getTableData()
      }).catch(err => {
        this.$message.error(err || '下架商品失败')
      })
    }
  }
}
</script>
